// Factory function para busca de Pedidos de Venda
export const criarConfigBuscaPedidoVenda = (idOrganizacao) => ({
  label: 'Pedido de Venda',
  placeholder: 'Nº Pedido ou Cliente...',
  titulo: 'Pesquisar Pedido de Venda',
  endpointApi: 'PedidoVendas',
  idField: 'idPedidoVenda',
  displayField: 'numeroPedidoVenda',
  descField: 'nomeCliente',
  camposFiltro: [
    { label: 'Nº Pedido ou Cliente', model: 'busca', tipo: 'text' }
  ],
  colunasGrid: [
    { header: 'Nº Pedido', dataField: 'numeroPedidoVenda', width: '30%' },
    { header: 'Cliente', dataField: 'nomeCliente', width: '40%' },
    { header: 'Status', dataField: 'lstStatusPedido', width: '30%' }
  ],
  filtrosFixos: { idOrganizacao }
})
